import React from 'react';
import {
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridPageCountSelector,
  gridRowCountSelector,
} from '@mui/x-data-grid';
import { TablePagination } from '@mui/material';

export function ResultsPaginationFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const handlePageChange = (_: unknown, newPage: number) => {
    apiRef.current.setPage(newPage);
  };

  return (
    <TablePagination
      component="div"
      count={rowCount}
      page={page}
      onPageChange={handlePageChange}
      rowsPerPage={100} // or whatever fixed page size you're using
      rowsPerPageOptions={[]} // hides the dropdown
      labelRowsPerPage="" // hides label text
    />
  );
}
